Hirer-provided text used for the location suggestions.

This currently expects a substring of a location's name (e.g. a suburb or city name).
Postcodes and street addresses are not supported.
